import { FunctionComponent, useEffect, useRef, useState } from 'react';

// Components
import { Collapse } from 'reactstrap';
// import Image from '@Components/Utils/Image';
// import Anchor from '@Components/Utils/Anchor';

// Contexts
import { useAppStore } from '@Components/AppStore/Context';
import AnchorComponent from './AnchorComponent';
// Utilities
import classnames from 'classnames';
// import { assetMedicalSpecialty } from '@Libs/utils';
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Styles
import styles from './MedicalSpecialties.module.scss';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowRight } from '@fortawesome/free-solid-svg-icons';

interface MedicalSpecialtiesProps {
    title?: string;
    activeCode?: string;

    className?: string;
    itemClassName?: string;
    listClassName?: string;
    linkClassName?: string;
    textClassName?: string;
    titleClassName?: string;
    imageClassName?: string;
    viewmoreClassName?: string;
    useRouter?: string;

    buildLink?(code: string): string;
}

const MedicalSpecialties: FunctionComponent<MedicalSpecialtiesProps> = ({
    title,
    activeCode,

    className,
    titleClassName,
    listClassName,
    itemClassName,
    linkClassName,
    imageClassName,
    textClassName,
    viewmoreClassName,
    useRouter,

    buildLink,
}) => {
    const { deviceType } = useViewDetected();
    const { allMedicalSpecialties } = useAppStore();
    const [viewMore, setViewMore] = useState<boolean>(false);

    useEffect(() => {
        (() => {
            let indexOf = -1;

            Object.values(allMedicalSpecialties).forEach(({ code }, index) => {
                if (code === activeCode) {
                    indexOf = index;
                }
            });

            if (indexOf >= 7) {
                setViewMore(true);
            }
        })();
    }, []);

    const listRef = useRef<HTMLUListElement>();
    const handleViewMore = () => setViewMore((viewMore) => !viewMore);

    const renderAfewMedicalSpecialties = () => {
        return Object.values(allMedicalSpecialties)
            .slice(0, 7)
            .map(({ code, name, id }) => {
                return (
                    <li className={classnames([styles.item, itemClassName])} key={`medical_specialty_${id}`}>
                        {/* <Anchor
                            href={buildLink(code)}
                            className={classnames([
                                styles.link,
                                linkClassName,
                                {
                                    [styles.active]: code === activeCode,
                                },
                            ])}
                        >
                            <Image className={classnames([styles.image, imageClassName])} src={assetMedicalSpecialty(code)} />

                            <span className={classnames([styles.text, textClassName])}>{name}</span>
                        </Anchor> */}
                        <AnchorComponent
                            useRouter={useRouter}
                            code={code}
                            name={name}
                            hrefAnchor={buildLink(code)}
                            classNameSpan={classnames([styles.text, textClassName])}
                            classNameImage={classnames([styles.image, imageClassName])}
                            classNameAnchor={classnames([
                                styles.link,
                                linkClassName,
                                {
                                    [styles.active]: code === activeCode,
                                },
                            ])}
                        />
                    </li>
                );
            });
    };

    const renderLastAllMedicalSpecialties = () => {
        return Object.values(allMedicalSpecialties)
            .slice(7)
            .map(({ code, name, id }) => {
                return (
                    <li className={classnames([styles.item, itemClassName])} key={`medical_specialty_${id}`}>
                        <AnchorComponent
                            useRouter={useRouter}
                            code={code}
                            name={name}
                            hrefAnchor={buildLink(code)}
                            classNameSpan={classnames([styles.text, textClassName])}
                            classNameImage={classnames([styles.image, imageClassName])}
                            classNameAnchor={classnames([
                                styles.link,
                                linkClassName,
                                {
                                    [styles.active]: code === activeCode,
                                },
                            ])}
                        />
                        {/* <Anchor
                            href={buildLink(code)}
                            className={classnames([
                                styles.link,
                                linkClassName,
                                {
                                    [styles.active]: code === activeCode,
                                },
                            ])}
                        >
                            <Image className={classnames([styles.image, imageClassName])} src={assetMedicalSpecialty(code)} />

                            <span className={classnames([styles.text, textClassName])}>{name}</span>
                        </Anchor> */}
                    </li>
                );
            });
    };

    return (
        <div className={classnames([styles.wrapper, styles[deviceType], className])}>
            <h3 className={classnames([styles.title], titleClassName)}>
                {title}

                <ViewMedia is={['mobile', 'tablet']}>
                    <FontAwesomeIcon width={16} height={16} className={styles.icon_arrow} icon={faArrowRight} />
                </ViewMedia>
            </h3>

            <ul ref={listRef} className={classnames([styles.list, listClassName])}>
                <li className={classnames([styles.item, itemClassName])}>
                    <AnchorComponent
                        useRouter={useRouter}
                        code={null}
                        name={'Tất cả'}
                        hrefAnchor={buildLink(null)}
                        classNameSpan={classnames([styles.text, textClassName])}
                        classNameImage={classnames([styles.image, imageClassName])}
                        classNameAnchor={classnames([
                            styles.link,
                            linkClassName,
                            {
                                [styles.active]: !activeCode,
                            },
                        ])}
                    />
                    {/* <Anchor
                        href={buildLink(null)}
                        className={classnames([
                            styles.link,
                            linkClassName,
                            {
                                [styles.active]: !activeCode,
                            },
                        ])}
                    >
                        <Image className={classnames([styles.image, imageClassName])} src={assetMedicalSpecialty('all')} />

                        <span className={classnames([styles.text, textClassName])}>Tất cả</span>
                    </Anchor> */}
                </li>

                {renderAfewMedicalSpecialties()}

                <ViewMedia is={['mobile', 'tablet']}>{renderLastAllMedicalSpecialties()}</ViewMedia>
            </ul>

            <ViewMedia is={['desktop']}>
                <Collapse isOpen={viewMore}>
                    <ul ref={listRef} className={classnames([styles.list, listClassName])}>
                        {renderLastAllMedicalSpecialties()}
                    </ul>
                </Collapse>
            </ViewMedia>

            <ViewMedia is={'desktop'}>
                <a className={classnames([styles.viewmore, viewmoreClassName, { [styles.active]: viewMore }])} onClick={handleViewMore}>
                    {viewMore ? 'Thu gọn' : 'Xem thêm'} <FontAwesomeIcon width={16} height={16} className={styles.icon_arrow} icon={faArrowDown} />
                </a>
            </ViewMedia>
        </div>
    );
};

MedicalSpecialties.defaultProps = {
    title: 'Chuyên khoa',
    buildLink: (code) => `/${code}`,
};

export default MedicalSpecialties;
